<template>
  <el-dialog title="计划详情" width="800px" :visible="isShow" :close-on-click-modal="false" @close="closeDialog">
    <div class="content">
      <p>项目名称：{{planInfo.projectName || '--'}}</p>
      <p>计划周期：{{planInfo.planStart || '--'}} 至 {{planInfo.planEnd || '--'}}</p>
      <p>任务抄送至：{{planInfo.userNames || '--'}}</p>
      <p class="count">已完成：<span>{{finished}}</span></p>
      <p class="count">未完成：<span style="color:#F97980;">{{planInfo.taskList ? planInfo.taskList.length - finished : 0}}</span></p>

      <div class="echart" ref="echart"></div>
      <el-collapse accordion @change="handleChange" v-model="active">
        <el-collapse-item v-for="(item, index) in planInfo.taskList" :key="index" :name="item.taskId">
          <template slot="title">
            <div class="title">
              <img v-if="item.taskState === '1'" src="../../assets/img/icon_finished.png">
              <img v-if="item.taskState === '0'" src="../../assets/img/icon_unfinished.png">
              <span>{{item.taskNotes}}</span>
            </div>
          </template>
          <div v-if="item.taskId === active && detail.length > 0">
            <p>现场作业</p>
            <div class="work">
              <div v-for="(item, index) in detail" :key="index">
                <p>作业日期：{{item.dailyDate || '--'}}&nbsp;&nbsp;&nbsp;&nbsp;提报人：{{item.dailyUserName || '--'}}</p>
                <custom-upload v-model="item.fileList" disabled></custom-upload>
                <p>备注：{{item.workNotes || '--'}}</p>
              </div>
            </div>
          </div>
          <NoData v-else></NoData>
        </el-collapse-item>
      </el-collapse>
    </div>
  </el-dialog>
</template>

<script>
// import * as echarts from 'echarts'
import NoData from '@/components/NoData.vue'
import CustomUpload from '@/components/CustomUpload.vue'
export default {
  name: 'planDetail',
  components: { NoData, CustomUpload },
  props: {
    planId: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    finished () {
      let count = 0
      if (this.planInfo && this.planInfo.taskList) {
        count = this.planInfo.taskList.filter(t => t.taskState === '1').length
      }
      return count
    }
  },
  watch: {
    isShow (val) {
      if (val) {
        this.loadDetail()
      }
    }
  },
  data () {
    return {
      planInfo: {},
      detail: [],
      active: ''
    }
  },
  created () {
  },
  methods: {
    loadDetail () {
      this.$axios.get(this.$apis.workPlan.selectYhDailyPlanByPlanId, {
        planId: this.planId
      }).then(res => {
        this.planInfo = res || []
        const total = this.planInfo && this.planInfo.taskList ? this.planInfo.taskList.length : 0
        this.renderEchart(this.finished, total)
      })
    },
    renderEchart (value, total) {
      this.$nextTick(() => {
        this._chart = echarts.init(this.$refs.echart)
        const option = {
          series: [{
            name: '11',
            type: 'pie',
            clockWise: false,
            radius: ['75%', '100%'],
            itemStyle: {
              normal: {
                color: '#449BFF',
                shadowBlur: 0,
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                }
              }
            },
            hoverAnimation: false,
            data: [
              {
                value: value,
                label: {
                  normal: {
                    formatter: params => {
                      return '{title' + `|${(+params.value / total * 100).toFixed(1)}` + '%}' + '\n' + '{name|完成率}'
                    },
                    rich: {
                      name: {
                        color: '#666666',
                        fontSize: 12,
                        lineHeight: 20
                      }
                    },
                    position: 'center',
                    show: true,
                    textStyle: {
                      fontSize: 14,
                      color: '#449BFF'
                    }
                  }
                }
              },
              {
                value: total === 0 ? 100 : total - value,
                name: 'invisible',
                itemStyle: {
                  normal: {
                    color: '#E0E0E0'
                  }
                }
              }
            ]
          }]
        }
        this._chart.clear()
        this._chart.setOption(option)
      })
    },
    handleChange (val) {
      this.detail = []
      if (val) {
        this.$axios.get(this.$apis.workPlan.selectYhDailyWorkByList, {
          taskId: val
        }).then((res) => {
          this.detail = res || []
        })
      }
    },
    // 关闭
    closeDialog () {
      this.$emit('update:isShow', false)
    }
  }
}
</script>

<style scoped lang="scss">
  .content{
    position: relative;
    p{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 22px;
      font-style: normal;
      margin-bottom: 20px;
      &.count{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #565656;
        font-style: normal;
        span{
          color:#89D762;
        }
      }
    }
  }
  ::v-deep {
    .el-collapse{
      margin: 30px 0 30px 30px;
      border: 0;
      .el-collapse-item{
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 30px;
        }
      }
      .el-collapse-item__header{
        position: relative;
        height: auto;
        background: #FAFAFA;
        border: 1px solid #EBEBEB;
        padding: 10px 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        line-height: 30px;
        color: #000000;
        img{
          position: absolute;
          left: -30px;
          top: 20px;
        }
      }
      .el-collapse-item__content{
        background: #FFFFFF;
        border: 1px solid #EBEBEB;
        padding: 20px;
        border-bottom: 0;
        border-top: 0;
        max-height: 450px;
        overflow: auto;
      }
    }
  }
  .echart{
    position: absolute;
    width: 90px;
    height: 90px;
    right: 20px;
    top: 20px;
  }
  .work{
    display: flex;
    flex-wrap: wrap;
    >div{
      width: 50%;
    }
  }
</style>
